import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../../config/api";
import { useParams } from "react-router-dom";

export function useCustomerDetails() {
  const { id } = useParams(); // ✅ customer id from URL
  const customerId = id;

  const [customer, setCustomer] = useState(null);
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchCustomer = async () => {
    if (!customerId) return;
    try {
      setLoading(true);
      setError("");
      const res = await axios.get(
        `${BASE_URL}warranty/get-customer-details?id=${customerId}`
      );
      setCustomer(res.data);
      setDevices(res.data?.devices || []);
    } catch (e) {
      console.error(e);
      setError("Failed to load customer details.");
      setCustomer(null);
      setDevices([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomer();
  }, [customerId]);

  return { customer, devices, loading, error, refetch: fetchCustomer };
}




// import { useEffect, useState } from "react";
// import axios from "axios";
// import { BASE_URL } from "../../../config/api";

// export function useCustomerDetails() {
//   const authUser = JSON.parse(localStorage.getItem("authUserData") || "null");
//   const customerId = authUser?.id;

//   const [customer, setCustomer] = useState(null);
//   const [devices, setDevices] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const fetchCustomer = async () => {
//     if (!customerId) return;
//     try {
//       setLoading(true);
//       setError("");
//       const res = await axios.get(`${BASE_URL}warranty/get-customer-details?id=${customerId}`);
//       setCustomer(res.data);
//       setDevices(res.data?.devices || []);
//     } catch (e) {
//       console.error(e);
//       setError("Failed to load customer details.");
//       setCustomer(null);
//       setDevices([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCustomer();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [customerId]);

//   return { customerId, customer, devices, loading, error, refetch: fetchCustomer };
// }


